import { memo } from 'react';
import { cn } from '@/utils/cn';
import { ISO3166Alpha2OrUnknown } from '@bits/i18n';
import { CircleFlag } from '@bits/i18n/circle-flag';

import { countryCodeToName } from '@/lib/country-code';

export const MarketFlag = memo(
  ({
    countryAlpha2,
    variant,
    short,
    className,
  }: {
    countryAlpha2?: ISO3166Alpha2OrUnknown | null;
    variant?: 'medium' | 'small';
    short?: boolean;
    className?: string;
  }) => {
    const countryName =
      countryAlpha2 === 'Unknown' || !countryAlpha2
        ? short
          ? 'N/A'
          : 'Unknown'
        : short
          ? countryAlpha2
          : countryCodeToName(countryAlpha2);

    return (
      <div
        className={cn('inline-flex items-center gap-2 leading-5', className)}
      >
        <CircleFlag
          countryCode={countryAlpha2 || 'Unknown'}
          className={cn('size-4 shrink-0 rounded-full object-cover', {
            'size-3': variant === 'small',
          })}
        />
        {countryName}
      </div>
    );
  }
);

MarketFlag.displayName = 'MarketFlag';

export const MarketFlagList = memo(
  ({ markets }: { markets: ISO3166Alpha2OrUnknown[] }) => {
    return (
      <div className="flex">
        {markets.map((market, index) => (
          <div key={index} className="-ml-1">
            <CircleFlag className="size-6" countryCode={market} />
          </div>
        ))}
      </div>
    );
  }
);

MarketFlagList.displayName = 'MarketFlagList';
